import type { DecryptData } from '../types/singleReport';

/** Encrypted token returned inside a decrypt payload to follow in a second decrypt step. */
export function getChainedDecryptEurl(data: DecryptData | undefined): string {
  if (!data) {
    return '';
  }
  const raw = data.eURL ?? data.eUrl ?? data.eurl ?? '';
  return typeof raw === 'string' ? raw.trim() : '';
}
